import React from 'react';
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { useTranslation } from 'react-i18next';

const Card = ({ number, team1, team2, odd, choosen, handleRemoveCard, match, normalColor = true }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const homeTeamName = i18n.language === 'en' ? team1 : match.homeTeamMyan;
  const awayTeamName = i18n.language === 'en' ? team2 : match.awayTeamMyan;

  const handleSongClick = () => {
    dispatch(playSong());
  };

  const removeCard = () => {
    handleSongClick();
    handleRemoveCard(match.rapidEventId);
  };

  return (
    <div className={`relative w-[95%] p-3 shadow-sm rounded-xl border mb-2
      ${normalColor 
        ? 'bg-white border-[#228B22]/20' 
        : 'bg-red-50 border-red-200'
      }`}>

      <div className="grid grid-cols-12 gap-2 items-center text-sm text-gray-800">
        {/* Match Number */}
        <div className="col-span-1 text-md font-bold text-[#228B22]">
          {number}
        </div>

        {/* Team Names */}
        <div className="col-span-5 space-y-1">
          <div className="font-medium text-gray-900">
            {homeTeamName}
          </div>
          <div className="font-medium text-gray-600">
            {awayTeamName}
          </div>
        </div>

        {/* Odd */}
        <div className="col-span-2 text-center">
          <div className="inline-block px-2 py-1 text-xs rounded-full bg-[#FFD700]/20 text-[#B8860B] font-semibold">
            {odd}
          </div>
        </div>

        {/* Chosen Team */}
        <div className="col-span-4 flex justify-end">
          <div className="text-xs px-3 py-1 bg-[#228B22]/10 text-[#228B22] rounded-full font-medium">
            {choosen === 'home' ? homeTeamName : choosen === 'away' ? awayTeamName : choosen}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
